module.exports = __webpack_public_path__ + "img/swiss-1.391cbf63.jpg";